import { Badge, FormatNumber, HStack, Stack, Stat } from '@chakra-ui/react';
import { memo } from 'react';

const StockCard = () => {
  return (
    <Stat.Root
      w="100%"
      bg="sidebar.background"
      borderColor="border.light"
      _hover={{ bg: 'sidebar.hover' }}
      cursor="pointer"
      borderWidth="1px"
      p="4"
      rounded="md"
    >
      <Stat.Label>Stock</Stat.Label>
      <HStack>
        <Stat.ValueText>
          <FormatNumber value={10} />
        </Stat.ValueText>
      </HStack>
    </Stat.Root>
  );
};

const SalesCard = () => {
  return (
    <Stat.Root
      w="100%"
      bg="sidebar.background"
      borderColor="border.light"
      _hover={{ bg: 'sidebar.hover' }}
      cursor="pointer"
      borderWidth="1px"
      p="4"
      rounded="md"
    >
      <Stat.Label>Sales</Stat.Label>
      <HStack>
        <Stat.ValueText>
          <FormatNumber value={1000.4} style="currency" currency="USD" />
        </Stat.ValueText>
        <Badge colorPalette="green" gap="0">
          <Stat.UpIndicator />
          12%
        </Badge>
      </HStack>
      <Stat.HelpText>since last month</Stat.HelpText>
    </Stat.Root>
  );
};

const RevenueGrowthCard = () => {
  return (
    <Stat.Root
      w="100%"
      bg="sidebar.background"
      borderColor="border.light"
      _hover={{ bg: 'sidebar.hover' }}
      cursor="pointer"
      borderWidth="1px"
      p="4"
      rounded="md"
    >
      <Stat.Label>Revenue Growth</Stat.Label>
      <HStack>
        <Stat.ValueText>
          <FormatNumber value={8456.4} style="currency" currency="USD" />
        </Stat.ValueText>
        <Badge colorPalette="green" gap="0">
          <Stat.UpIndicator />
          12%
        </Badge>
      </HStack>
      <Stat.HelpText>since last month</Stat.HelpText>
    </Stat.Root>
  );
};

const ProductStats = () => {
  return (
    <Stack direction={{ base: 'column', md: 'row' }} gap={4}>
      <StockCard />
      <SalesCard />
      <RevenueGrowthCard />
    </Stack>
  );
};

export default memo(ProductStats);
